import { NgModule } from "@angular/core";
import { SystemLanguagesPipe } from "./system-languages.pipe";
import { TrustUrlPipe } from "./trust-url.pipe";


@NgModule({
    declarations: [SystemLanguagesPipe, TrustUrlPipe],
    exports: [SystemLanguagesPipe, TrustUrlPipe],
    providers: [SystemLanguagesPipe, TrustUrlPipe]
})
export class PipeModule { }